import React, { useState, useEffect } from 'react'
import clsx from 'clsx';
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import ContactForm from '../public/ContactForm'
import Navigation from '../public/NavbarHomepage'
import { Button, TextField, Link, Grid, Container, MenuItem, Select } from '@material-ui/core';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import CheckIcon from '@material-ui/icons/Check';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import InputBase from '@material-ui/core/InputBase';
import { withTranslation } from 'react-i18next'
import { guestContactUs } from '../store/actions/userAction'
import Swal from 'sweetalert2'

const useStyles = makeStyles((theme) => ({
  containerNavbar: {
    [theme.breakpoints.down("sm")]: {
        background: '#191919', 
        padding: '0 25px'
    },
    [theme.breakpoints.up("sm")]: {
        background: '#191919', 
        padding: '0 64px'
    },
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  bgContainer: {
    background: 'rgb(255,255,255)',
    background: 'linear-gradient(180deg, rgba(255,255,255,1) 30%, rgba(240,240,240,1) 100%)',
    [theme.breakpoints.down("sm")]: {
      background: 'white',
      padding: '0 30px',
      marginTop: '-3rem'
    },
  },
  containerFormContact: {
    border: '2px solid #878787',
    borderRadius: '10px',
    padding: '20px 18px 18px 18px'
  },
  containerFormRight: {
    paddingLeft: '20px',
    [theme.breakpoints.down("sm")]: {
      paddingLeft: '0'
    },
  },
  placeholderSelect: {
    fontSize: '14px',
    fontStyle: 'unset', 
    color: '#9f9f9f'
  }
}));

const BootstrapInput = withStyles((theme) => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: 'transparent',
    border: '1px solid #ced4da',
    fontSize: 16,
    padding: '10px 26px 10px 12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:focus': {
      borderRadius: 4,
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
}))(InputBase);


const ContactUs = ({ t }) => {
    const classes = useStyles();
    const [ input, setInput ] = useState({
      fullName: '',
      companyName: '',
      email: '',
      phoneNumber: '',
      service: '',
      additionalInfo: ''
    })
    const history = useHistory()
    const dispatch = useDispatch()

    const [lang, setLang] = useState('')
    const [JmlKaryawan, setJmlKaryawan] = useState('')
    const [Posisi, setPosisi] = useState('')
    const [Dept, setDept] = useState('')

    const handleSubmit = (e) => {
      e.preventDefault()
      const regexUrl = /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/gm;
      if (!(input.companyName.match(regexUrl))) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid URL',
          text: 'Please input valid company name URL',
        })
      } else {
        const payload = JSON.parse(JSON.stringify(input))
        payload.companySize = JmlKaryawan;
        payload.position = Posisi;
        payload.department = Dept;
        dispatch(guestContactUs(payload))
      }
    }

    const handleChange = (e) => {
      let { name, value } = e.target
      setInput({ ...input, [name]: value })
    }


    const handleChangeJmlKaryawan = (event) => {
      setJmlKaryawan(event.target.value);
    };
  
    const handleChangePosisi = (event) => {
      setPosisi(event.target.value);
    };

    const handleChangeDept = (event) => {
      setDept(event.target.value);
    };
    
    const setLocale = (locale) => {
      setLang(locale)
    }

    const handleRegister = (e) => {
      history.push('/register')
    }

    const jmlKaryawan = [
      '1-13',
      '14 - 55',
      '56 - 150',
      '>150'
    ];

    const posisi = [
      'Pemilik Perusahan',
      'Manager',
      'Contributor',
      'Lainnya'
    ];

    const dept = [
      'Production',
      'Research and Development' ,
      'Purchasing',
      'IT',
      'Marketing',
      'Dev / Engineering' ,
      'Strategy / Biz Dev' ,
      'HRD'
    ];

    return (
    <>
      <Container className={classes.containerNavbar} maxWidth="xl" >
        <Navigation locale={setLocale}/>
      </Container>
      <div className={classes.bgContainer}>
        <Container className="contactUsPage py-5 px-0" component="main" maxWidth="md">
            <Grid container direction="row" alignItems="center">
            <Grid xs={12} md={5} className="align-self-start mt-40">
                <h4 className="mb-20">
                  {t('contactUs.contactUs')}
                </h4>
                <p className="reguler mb-15">
                  {t('contactUs.titleTxt')}
                </p>
                <table>
                  <tr>
                    <td><CheckIcon className="mr-5" style={{color: '#24d90e'}}/></td>
                    <td className='reguler'>{t('contactUs.subTitle1')}</td>
                  </tr>
                  <tr>
                    <td><CheckIcon className="mr-5" style={{color: '#24d90e'}}/></td>
                    <td className='reguler'>{t('contactUs.subTitle2')}</td>
                  </tr>
                  <tr>
                    <td><CheckIcon className="mr-5" style={{color: '#24d90e'}}/></td>
                    <td className='reguler'>{t('contactUs.subTitle3')}</td>
                  </tr>
                </table>
                <h3 className="mb-20 mt-50">
                  BINC TEKNOLOGI GRUP
                </h3>
                <p className="reguler">
                  Treasury Tower, Lt 31<br/>
                  Jl. Jend. Sudirman Kav. 52-53 Jakarta 12190<br/>
                  contact@getquickey.com
                </p>
            </Grid>
            <Grid container xs={12} md={7} className={classes.containerFormRight}>
              <Grid container xs={12} md={12} className={classes.containerFormContact}>
                <Grid item xs={12} md={12} className="justify-content-between">
                  <form onSubmit={handleSubmit}>
                  <Grid container className="mb-30">
                    <a style={{textDecoration: 'none'}} target="_blank"
                    href="https://api.whatsapp.com/send/?phone=+6281210614476&text=Halo..%0ASaya+Menghubungi+anda+untuk+tanya+Quickey+lebih+detail.&app_absent=0">
                      <Button
                      variant="contained"
                      className="btn-green text-transform-unset"
                      style={{padding: "5px 10px"}}
                      >
                      <WhatsAppIcon style={{fontSize: '22px', marginTop: '-2px'}}/>&thinsp;{t('contactUs.whatsapp')}
                      </Button>
                    </a>
                    <span className="ml-10 reguler align-self-center">
                      {t('contactUs.formTitle')}
                    </span>
                  </Grid>
                  <Grid container spacing={4}>
                    <Grid item xs={12} md={6}>
                      <p className="font-size-16 reguler" style={{marginBottom: "-5px"}}>{t('contactUs.fullName')}</p>
                      <TextField
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      id="fullName"
                      name="fullName"
                      required
                      onChange={handleChange}
                      placeholder={t('contactUs.placeholderName')}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}> 
                      <p className="font-size-16 reguler" style={{marginBottom: "-5px"}}>{t('contactUs.email')}</p>
                      <TextField
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      name="email"
                      id="email"
                      required
                      onChange={handleChange}
                      placeholder={t('contactUs.placeholderEmail')}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={4}>
                    <Grid item xs={12} md={6}>
                      <p className="font-size-16 reguler" style={{marginBottom: "-5px"}}>{t('contactUs.companyName')}</p>
                      <TextField
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      id="companyName"
                      name="companyName"
                      required
                      onChange={handleChange}
                      placeholder={t('contactUs.placeholderCompany')}
                      helperText={t('contactUs.placeholderCompanyHelper')}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}> 
                      <p className="font-size-16 reguler" style={{marginBottom: "-5px"}}>{t('contactUs.phoneNumber')}</p>
                      <TextField
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      name="phoneNumber"
                      id="phoneNumber"
                      required
                      onChange={handleChange}
                      placeholder={t('contactUs.placeholderNumber')}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={4}>
                    <Grid item xs={12} md={6}>
                      <p className="font-size-16 reguler" style={{marginBottom: "-5px"}}>{t('contactUs.companySize')}</p>
                      <Select
                        fullWidth
                        displayEmpty
                        required
                        value={JmlKaryawan}
                        onChange={handleChangeJmlKaryawan}
                        input={<BootstrapInput />}
                        inputProps={{ 'aria-label': 'Without label' }}
                        style={{margin: '8px 0 4px 0'}}
                      >
                        <MenuItem disabled value="">
                          <em className={classes.placeholderSelect}>{t('contactUs.placeholderCompanySelect')}</em>
                        </MenuItem>
                        {jmlKaryawan.map((jmlKaryawan) => (
                          <MenuItem key={jmlKaryawan} value={jmlKaryawan}>
                            {jmlKaryawan}
                          </MenuItem>
                        ))}
                      </Select>
                    </Grid>
                    <Grid item xs={12} md={6}> 
                      <p className="font-size-16 reguler" style={{marginBottom: "-5px"}}>{t('contactUs.role')}</p>
                      <Select
                        fullWidth
                        displayEmpty
                        required
                        value={Posisi}
                        onChange={handleChangePosisi}
                        input={<BootstrapInput />}
                        inputProps={{ 'aria-label': 'Without label' }}
                        style={{margin: '8px 0 4px 0'}}
                      >
                        <MenuItem disabled value="">
                          <em className={classes.placeholderSelect}>{t('contactUs.placeholderCompanySelect')}</em>
                        </MenuItem>
                        {posisi.map((posisi) => (
                          <MenuItem key={posisi} value={posisi}>
                            {posisi}
                          </MenuItem>
                        ))}
                      </Select>
                    </Grid>
                  </Grid>
                  <Grid container spacing={4}>
                    <Grid item xs={12} md={6}>
                      <p className="font-size-16 reguler" style={{marginBottom: "-5px"}}>{t('contactUs.dept')}</p>
                      <Select
                        fullWidth
                        displayEmpty
                        required
                        value={Dept}
                        onChange={handleChangeDept}
                        input={<BootstrapInput />}
                        inputProps={{ 'aria-label': 'Without label' }}
                        style={{margin: '8px 0 4px 0'}}
                      >
                        <MenuItem disabled value="">
                          <em className={classes.placeholderSelect}>{t('contactUs.placeholderCompanySelect')}</em>
                        </MenuItem>
                        {dept.map((dept) => (
                          <MenuItem key={dept} value={dept}>
                            {dept}
                          </MenuItem>
                        ))}
                      </Select>
                    </Grid>
                    <Grid item xs={12} md={6}> 
                      <p className="reguler" style={{marginBottom: "-3px", fontSize: '15px'}}>{t('contactUs.service')}</p>
                      <TextField
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      name="service"
                      id="service"
                      required
                      onChange={handleChange}
                      placeholder={t('contactUs.placeholderService')}
                      />
                    </Grid>
                    <Grid item xs={12} md={12}>
                    <p className="font-size-16 reguler" style={{marginBottom: "5px"}}>{t('contactUs.anything')}</p>
                    <TextField
                      id="otherInfo outlined-multiline-static"
                      variant="outlined"
                      margin="none"
                      size="small"
                      placeholder={t('contactUs.placeholderAnything')}
                      defaultValue=""
                      fullWidth
                      multiline
                      rows={4}
                      name="additionalInfo"
                      onChange={handleChange}
                    />
                    <p className="font-size-12 mb-0">*{t('contactUs.mandatory')}</p>
                    </Grid>
                    <Grid item xs={12} md={12} style={{textAlign: "center", paddingTop: "0"}}>
                    <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className="btn-black text-transform-unset"
                    style={{padding: "5px 40px"}}
                    >
                      Submit
                    </Button>
                    </Grid>
                  </Grid>
                  </form>
                </Grid>
              </Grid>
            </Grid>
            </Grid>
        </Container>
      </div>
      <div>
        <ContactForm/>
      </div>
    </>
    )
}

export default withTranslation()(ContactUs)
